import './IssueLabelToken-a5fe569e.css';

var classes = {"IssueLabel":"prc-Token-IssueLabel-ZuoEW","RemoveButton":"prc-Token-RemoveButton-H4Dmg"};

export { classes as default };
